module.exports = __webpack_public_path__ + "img/portrait_daniel.636674ce.jpg";